/* eslint-disable prettier/prettier */
export type PersonalizationError = {
  type: {
    symbol: string;
    emoji: string;
    length: string;
    noError: string;
  };
  list: {
    symbol: string;
    emoji: string;
    length: string;
  };
};

const personalizationErrorList: PersonalizationError = {
  type: {
    symbol: 'symbol',
    emoji: 'emoji',
    length: 'length',
    noError: 'noError',
  },
  list: {
    symbol: 'Unable to add item to basket as the personalised field contains illegal characters',
    emoji: 'Unfortunately emojis aren\'t supported. Please remove them in order to continue',
    length: 'Personal message is too long',
  },
};

export default personalizationErrorList;
